/**
 * Faixa de identificação do ambiente exibida acima do header.
 *
 * O ambiente é resolvido pelo HOST, e não por `import.meta.env`: o mesmo build
 * é publicado em mais de um domínio, então só a URL distingue com segurança
 * onde o portal está rodando. Produção (`portal.alba.com.br`) não recebe faixa,
 * e qualquer host desconhecido também não — assim um domínio novo nunca passa a
 * exibir a faixa por acidente em cima do usuário final.
 *
 * `localhost` cobre também `127.0.0.1` e os IPs da rede local que o Vite expõe
 * com `--host`, usados para abrir o portal local no celular.
 */
export type EnvironmentBanner = {
  label: string;
  className: string;
};

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]', '0.0.0.0'];

const PRIVATE_NETWORK_HOSTNAME =
  /^(10\.|127\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/;

function isLocalHostname(hostname: string): boolean {
  return (
    LOCAL_HOSTNAMES.includes(hostname) ||
    hostname.endsWith('.localhost') ||
    PRIVATE_NETWORK_HOSTNAME.test(hostname)
  );
}

export function getEnvironmentBanner(
  hostname: string = typeof window === 'undefined'
    ? ''
    : window.location.hostname
): EnvironmentBanner | null {
  const host = hostname.trim().toLowerCase();
  if (!host) return null;

  if (isLocalHostname(host)) {
    return { label: 'Ambiente Local', className: 'bg-red-600' };
  }

  if (host === 'portal-dev.alba.com.br') {
    return { label: 'Ambiente de Desenvolvimento', className: 'bg-red-600' };
  }

  if (host === 'portal-qa.alba.com.br') {
    return { label: 'Ambiente de Homologação', className: 'bg-red-600' };
  }

  return null;
}
